import { render, staticRenderFns } from "./AddBusinessTableHis.vue?vue&type=template&id=12393dd9&scoped=true"
import script from "./AddBusinessTableHis.vue?vue&type=script&lang=js"
export * from "./AddBusinessTableHis.vue?vue&type=script&lang=js"
import style0 from "./AddBusinessTableHis.vue?vue&type=style&index=0&id=12393dd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12393dd9",
  null
  
)

export default component.exports